import React, { useEffect, useState } from "react";
import FooterUser from "../component/sharedComponents/footer";
import SidebarAdmin from "../component/accountAdmin/sideBarAdmin";
import HeaderDashboard from "../component/sharedComponents/HeaderDashboard";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../redux/constent";
import { useTranslation } from "react-i18next";
import { changeUserLanguage } from "../redux/reducer/languageReducer";
import { useDispatch } from "react-redux";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const [tokenFound, setTokenFound] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [direction, setDirection] = useState(
    localStorage.getItem("language") === "ar" ? "rtl" : "ltr"
  );

  // Screen width checker
  useEffect(() => {
    const checkWidth = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  useEffect(() => {
    const handleLanguageChangeAndFetch = async () => {
      const currentLang = localStorage.getItem("language");

      if (currentLang === "ar") {
        localStorage.setItem("language", "en");

        await dispatch(changeUserLanguage());

        if (!location.pathname.startsWith("/en")) {
          const pathAfterLang = location.pathname.replace(/^\/(ar|en)/, "");
          window.location.replace(`/en${pathAfterLang}`);
          return;
        }

        document.documentElement.dir = "ltr";
        i18n.changeLanguage("en");
        setDirection("ltr");
      }

      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/login", { state: true });
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/myData`, {
          headers: { token },
        });
        const role = response?.data?.data?.user?.role;
        setUserRole(role);
        setTokenFound(true);
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/login", { state: true });
      } finally {
        setLoading(false);
      }
    };

    handleLanguageChangeAndFetch();
  }, [location.pathname, navigate, i18n, dispatch]);

  if (loading) return null;

  if (isMobile) {
    return (
      <div className="flex items-center justify-center min-h-screen px-4 text-xl font-semibold text-center text-red-600">
        🚫 This dashboard is only available on desktop devices. Please switch to
        a desktop or PC.
      </div>
    );
  }

  return (
    <div>
      <HeaderDashboard />
      <div className="mt-[55px] md:mt-[54px] lg:mt-[75px]">
        {userRole === "admin" ? (
          <SidebarAdmin />
        ) : (
          <div className="mt-10 text-xl font-semibold text-center text-red-600">
            ❌ You don’t have access to this page.
          </div>
        )}
      </div>
      <FooterUser />
    </div>
  );
};

export default Dashboard;
